import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-qep-button',
  templateUrl: './qep-button.component.html',
  styleUrls: ['./qep-button.component.scss']
})
export class QepButtonComponent {

  @Input() variant: 'filled' | 'outlined' = 'filled';
  @Input() icon: string;
  @Input() label: string;
  @Input() disabled: boolean;

}
